import { useState, useEffect } from 'react';

import Cabecalho from './Cabecalho';
import Principal from './Principal';
import BarraLateral from './BarraLateral';
import AvisoMensalidade from 'components/Mensalidade/AvisoMensalidade';
import ModalAvisoCritico from 'components/Avisos/ModalAvisoCritico';
import useAvisos from 'hook/avisos';
import { Redirect } from 'react-router-dom';
import http from 'services/http';

function Layout({ component, ...rest }) {
	const [menuAberto, setMenuAberto] = useState(false);
	const [perfilAberto, setPerfilAberto] = useState(false);
	const [usuario, setUsuario] = useState([]);
	const [token, setToken] = useState([]);

	// Avisos da Setebit: uma chamada só alimenta o sino do cabeçalho e o modal do
	// aviso crítico, que fica na frente do painel até ser marcado como lido.
	const avisos = useAvisos();

	useEffect(() => {
		const getUser = async () => {
			const getToken = localStorage.getItem('token');
			setToken(JSON.parse(getToken));

			try {
				const { data: { data } } = await http.get('/perfil');
				const usuarioAtualizado = data.usuario;
				localStorage.setItem('usuario', JSON.stringify(usuarioAtualizado));
				localStorage.setItem('nivel', usuarioAtualizado.nivel);
				setUsuario(usuarioAtualizado);
			} catch {
				const usuario = localStorage.getItem('usuario');
				setUsuario(JSON.parse(usuario));
			}
		};
		getUser();
	}, []);

	return (
		<div className="page-container">
			{!token === null && <Redirect to={{ pathname: '/login' }} />}
      <BarraLateral user={usuario} />
			<div className="left-content">
				<Cabecalho
					setperfilAberto={() => setPerfilAberto()}
					perfilAberto={perfilAberto}
					user={usuario}
					avisos={avisos}
					collapsed={() => {
						setMenuAberto(!menuAberto);
					}}
				/>

				<AvisoMensalidade />

				<ModalAvisoCritico criticos={avisos.criticos} marcarLido={avisos.marcarLido} />

				<Principal {...rest} component={component} />
			</div>
    </div>
	);
}

export default Layout;
